	//var loadButton = document.getElementById('load-more');
    var userFeed = new Instafeed({
        get: 'user',
        userId: 290189394,
        accessToken: '290189394.1677ed0.bceac2586ffb433d9e104a794eb4b449',
		template: '<li><a href="{{link}}" target="_blank"><img src="{{image}}" /></a></li>',
		sortBy: 'most-recent',
		limit: 1000,
		resolution: 'standard_resolution',
    });
	
    userFeed.run();